import { render, staticRenderFns } from "./ticket_info.vue?vue&type=template&id=701692ae&scoped=true"
import script from "./ticket_info.vue?vue&type=script&lang=js"
export * from "./ticket_info.vue?vue&type=script&lang=js"
import style0 from "./ticket_info.vue?vue&type=style&index=0&id=701692ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701692ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701692ae')) {
      api.createRecord('701692ae', component.options)
    } else {
      api.reload('701692ae', component.options)
    }
    module.hot.accept("./ticket_info.vue?vue&type=template&id=701692ae&scoped=true", function () {
      api.rerender('701692ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/ticket_info.vue"
export default component.exports